export var FlowEntityType;
(function (FlowEntityType) {
    FlowEntityType["Encounter"] = "encounter";
    FlowEntityType["EhrInformation"] = "ehrInformation";
    FlowEntityType["PatientOrder"] = "patientOrder";
    FlowEntityType["ExternalDocumentPacket"] = "externalDocumentPacket";
})(FlowEntityType || (FlowEntityType = {}));
//# sourceMappingURL=entityType.js.map